import * as z from 'zod/mini';
import { NAME_MAX_LENGTH, NOTES_MAX_LENGTH, SHORT_TEXT_MAX_LENGTH } from '../constants.ts';

// Field shapes shared by every entity. Names are trimmed and bounded; free
// text is bounded; ids are the UUIDs the Worker generates.

export const idSchema = z.string().check(z.uuid());

export const timestampSchema = z.string().check(z.minLength(1));

/** A calendar date as a date input gives it: 'YYYY-MM-DD', a real day of the calendar. */
export const dateSchema = z.iso.date('A date is YYYY-MM-DD');

export const nameSchema = z
  .string()
  .check(z.trim(), z.minLength(1, 'Required'), z.maxLength(NAME_MAX_LENGTH));

/** A name the server fills in when left blank (items: see item-names.ts). */
export const optionalNameSchema = z.string().check(z.trim(), z.maxLength(NAME_MAX_LENGTH));

export const shortTextSchema = z.string().check(z.trim(), z.maxLength(SHORT_TEXT_MAX_LENGTH));

export const notesSchema = z.string().check(z.maxLength(NOTES_MAX_LENGTH));

export const sortOrderSchema = z.int();

/** The identity of any node a photo or cable drop can point at. */
export const NODE_TYPES = ['client', 'property', 'room', 'rack', 'item', 'drop'] as const;
export type NodeType = (typeof NODE_TYPES)[number];
export const nodeTypeSchema = z.enum(NODE_TYPES);

export const pathEntrySchema = z.object({
  type: nodeTypeSchema,
  id: idSchema,
  name: z.string(),
  /** Absent only in a legacy offline cache or a non-node breadcrumb. */
  identifier: z.optional(z.string()),
  /** A child can hang from a numbered port on this item. */
  port: z.optional(z.int().check(z.positive())),
});
export type PathEntry = z.infer<typeof pathEntrySchema>;
export const pathSchema = z.array(pathEntrySchema);
